import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import './css/track.css';
import MeterCircle from '../MeterCircle/MeterCircle';
import {checkText,getFullDate} from '../../../../util/util';
import moment from 'moment';


class TrackingCrad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            detailTrackCard: this.props.info
        }
    }
    componentDidMount(){
    //    this.setEvent();

    }
    componentDidUpdate(){
    //    this.setEvent();
    }
    setEvent(){
        let {track,trackHistory,tname} = this.props;
        if(!track && !trackHistory)
            return;
        let gsm = track?track.gsm:trackHistory.gsm;
        let gps = track?track.gps:trackHistory.gps;
        let expire_date = track?track.device_info.expire_date:this.props.info.expire_date;
        let car_type = track?track.device_info.car_type:this.props.info.car_type;
        let remarks = track?track.device_info.remarks:this.props.info.remarks;
        
        let flipCard = $("#" + tname + " .tile");
       
        $( "#" + tname + " .settings").unbind( "click" );
        $("#" + tname + " .settings").click(function(){
            
            if($("#"+tname+'_back').length==0){
                $(flipCard).append('<div id="'+tname+'_back" class="back">' +
                    '<div  style="font-size: 12px " class="row row-striped col-12">' +
                        '<div class="col-6">'+
                            '<div class="col-12">' +
                                '<span class="text-strong d-none d-sm-inline-block">รายละเอียด</span>'+checkText(car_type,"-",25)+
                            '</div>'+
                            
                            '<div class="col-12">'+
                                '<span class="text-strong">ครบกำหนด</span>'+getFullDate(expire_date)+
                                
                            '</div>'+
                        '</div>'+
                        '<div class="col-6">'+
                            '<span class="text-strong">หมายเหตุ</span>'+checkText(remarks,"-",50)+
                        '</div>'+
                        '<div class="col-12">'+
                            '<div class="col-12">'+
                                '<span class="text-strong">GSM:</span>'+gsm+
                                '<span class="text-strong">GPS:</span>'+gps+
                                // '<a href="#" class="icon pe-7s-pin color-icon pull-right" style=margin-left:10px;margin-top:10px>'+
                                //     '<span>จุดสนใจ</span>'+
                                // '</a>'+
                                // '<a href="#" class="icon pe-7s-bell color-icon pull-right" style="margin-top:10px">'+
                                //     '<span>แจ้งเตือน</span>'+
                                // '</a>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="close">'+
                        '<div class="cy" />'+
                        '<div class="cx" />'+
                    '</div>'+
                '</div>');
                $("#" + tname + "_back .close").unbind( "click" );
                $("#" + tname + "_back .close").click(function(){
                  
                    $("#" + tname + "_back .cx, #" + tname + "_back .cy").removeClass('s1 s2 s3');
                    $(flipCard).removeClass('flip180').addClass('flip190');
        
                    setTimeout(function(){
                        $(flipCard).removeClass('flip190').addClass('flip90');
                    }, 50);
        
                    setTimeout(function(){
                        $("#" + tname + "_front").show();	$("#" + tname + "_back").hide();
                            $(flipCard).removeClass('flip90').addClass('flip-10');
        
                        setTimeout(function(){
                        $(flipCard).removeClass('flip-10').css('transition', '100ms ease-out');
                        }, 100);
                    }, 150);
        
                });
            }
            

            $(flipCard).addClass('flip-10');
            setTimeout(function(){
                $(flipCard).removeClass('flip-10').addClass('flip90');
            }, 50);

            setTimeout(function(){
                $(flipCard).removeClass('flip90').addClass('flip190');
                $("#" + tname + "_front").hide();	$("#" + tname + "_back").show();
                setTimeout(function(){
                    $(flipCard).removeClass('flip190').addClass('flip180');
                    $("#" + tname + "_back .cx, #" + tname + "_back .cy").addClass('s1');
                    setTimeout(function(){$("#" + tname + "_back .cx, #" + tname + "_back .cy").addClass('s2');}, 80);
                    setTimeout(function(){$("#" + tname + "_back .cx, #" + tname + "_back .cy").addClass('s3');}, 150);
                    setTimeout(function(){
                        $(flipCard).css('transition', '100ms ease-out');
                    }, 100);
                }, 100);
            }, 150);
        });

       
    }
    setStatus(status,w,speed){
        let c = "secondary";
        if(status=="จอด")
            c = "info"
        else if(status=="วิ่ง"){
            c = "success";
            if(speed)
                status = speed +" Km/h"
        }
        else if(status=="เร็ว"){
            c = "danger";
            if(speed)
                status = speed +" Km/h"
        }
           
        if(!w)
            w = 50;
        return(<span className={"badge badge-" + c} style={{paddingLeft:3,paddingRight:3,width: w}}>{status}</span>)
    }
    selectCard(index,device_no,lat,lng){
        if(this.props.onSelect)
            this.props.onSelect(index,device_no,lat,lng);
    }
    onMarkPointClick(){
        if(this.props.onMarkPointClick)
            this.props.onMarkPointClick();
    }

    render() {
        const {track,trackHistory} = this.props;
        //console.log("xxxxx",track,trackHistory)
        if((!track || (track && !track.status) ) && (!trackHistory || (!trackHistory && !trackHistory.status)) )
            return <div></div>;
        let status = track?track.status:trackHistory.status;
        let device_no = track?track.device_info.device_no:this.props.info.device_no;
        let visible = track?track.device_info.visible:true;
        let expire_date = track?track.device_info.expire_date:moment();
        let speed = track?track.speed:trackHistory.speed;
        let lat = track?track.latitude:trackHistory.lat;
        let lng = track?track.longitude:trackHistory.lng;
        let place = track?track.place:trackHistory.place;
        let date = track?track.date:trackHistory.date;
        let time = track?track.time:trackHistory.time;
        let driver_name = track?track.driver_name:trackHistory.driver_name;
        let driver_no = track?track.driver_no:trackHistory.driver_no;
        let driver_contact = track?track.device_info.driver_contact:trackHistory.driver_contact;
        let is_dlt_alert = track?track.device_info.is_dlt_alert:this.props.info.is_dlt_alert;
        let driver_by_tracker = track?track.driver_by_tracker:trackHistory.driver_by_tracker;
        let fuel =  track?track.fuel:trackHistory.fuel;
        // if(status=="ดับ")
        //     fuel = "-";

        let speed_limit = track?track.device_info.speed_limit:this.props.info.speed_limit;
        let speedColor = "bule";
        let isCrad = "";
        //console.log("is_dlt_alert",this.props.info,driver_by_tracker,time)
        if(is_dlt_alert && !driver_by_tracker && status!="ดับ"  && status!="เสา"){
            // device_no +="(ไม่รูดบัตร !)";
            isCrad = "(ไม่รูดบัตร!)";
            //console.log("is_dlt_alert",driver_name,time)
        }
        else if(driver_by_tracker){
            isCrad ="(รูดบัตร)";
            driver_name =  driver_name;
            driver_contact = driver_no;
            //console.log("is_dlt_alert",driver_name,time)
        }
            

        if(speed_limit && speed_limit!==null && status!="วิ่ง"){
            if(parseInt(speed_limit) < parseInt(speed)) 
                speedColor = "red";
        }
        let isHitory = false;
        if(trackHistory)
            isHitory = true;
        let place1 ="";
        let place2 =place;
        let place3 ="";
        if(place.split(")$").length>1){
            place1 = place.split(")$")[0] + ")";
            place2 = place.split(")$")[1];
            if(place2.split("#,").length>1){
                place2 = place2.split("#,")[0] + ",";
                place3 = place2.split("#,")[1];
            }
        }else if(place.split("#,").length>1){
            place2 = place.split("#,")[1];
            if(place2.split("#,").length>1){
                place3 = place2.split("#,")[1];
            }
        }
        if( (place1+place2).length>60 ){
            let t = place1+"$"+place2;
            // t = t.substring(0,60)+"..";
            let a = t.split("$");
            place1 = a[0];
            if(a.length==2)
                place2 = a[1];
        }
        if(!visible){
            place1 = "-";
            place2 = "";
            place3 = "";
        }

        let dEpire_date = moment(expire_date, "DD-MM-YYYY")
        let dnow = moment();
        // if(visible && dnow > dEpire_date)
        // console.log("datex "+device_no,dnow,dEpire_date,dnow<dEpire_date)
        return (
            <div id={this.props.tname} className="make-3D" onClick = {this.selectCard.bind(this,this.props.index,device_no,lat,lng)} >
                <div className="tile">
                    <div id={this.props.tname+"_front"} className="col-12" >
                        <div className="row row-striped col-12">
                           {
                               $(window).width()>766?
                               <div className="col-1 " >
                                
                                    {this.setStatus(status)}
                               
                                
                            </div>:""
                           }
                            
                            {
                                // $(window).width()>548?
                                $(window).width()>766?
                                <div className=" row col-11">
                                    <div className="col-8">
                                        <div title={device_no} className="text-uppercase" style={{ paddingLeft: 20,fontSize:17, fontWeight:'bold'
                                        , whiteSpace: "nowrap", overflow:"hidden" }}>
                                            <strong>{checkText(device_no,"-")}</strong><b style={{fontSize:12, color:"red"}}> {dnow <= dEpire_date?"" : " ครบกำหนด"}</b>
                                        </div>
                                    </div>
                                    
                                    {/* <div className="col-2 ">
                                        <MeterCircle cname={this.props.tname+"_Speed"} ctype={0} cvalue={speed} vcolor={speedColor}/>
                                    </div>
                                    
                                    <div className="col-2 ">
                                        <MeterCircle cname={this.props.tname+"_Gas"} ctype={1} cvalue={fuel}/>
                                    </div> */}
                                    <div className= "col-4" style={{fontSize:12, textAlign:"right",paddingTop:3,  color: "rgb(111, 111, 111)"}}>
                                        <b style={{paddingRight:5}}>{isCrad}</b>
                                    </div>
                                </div>
                                :
                                <div className="row col-12" >
                                    <div className="col-8 text-uppercase" style={{ marginLeft:-2,fontSize:18, fontWeight: 'bold'
                                    , whiteSpace: "nowrap", overflow:"hidden"  }}>
                                        <strong>{checkText(device_no,"-")}</strong><b style={{fontSize:12, color:"red"}}> {dnow <= dEpire_date?"" : " ครบกำหนด"}</b>
                                    </div>

                                    <div className= "col-4" style={{fontSize:12, textAlign:"right",paddingTop:3, color: "rgb(111, 111, 111)"}}>
                                        <b style={{paddingRight:5}}>{isCrad}</b>
                                    </div>
                                </div>
                            }
                            
                          
                            <div className="small-text" style={{position:"absolute",top:3,right:0,color:"#ccc",fontSize: 12}}>
                                {this.props.index+1}.
                            </div>
                            
                            <div className={$(window).width()>=766? "col-12 small-text ":"col-12 small-text "} >
                                <div  style={{paddingLeft:0}} data-toggle={driver_name + " " + driver_contact} title={driver_name + " " + driver_contact}>
                                    {/* <i className="far fa-address-card color-icon" style = {{marginRight: 3}}/>  */}
                                    <img src = "../images/icons/card.png" style = {{width:13}}></img>
                                    <span style = {{fontSize: 13, whiteSpace: "nowrap", overflow:"hidden", color:"#6f6f6f",marginLeft:3,position: "absolute" }}>
                                       {checkText(driver_name,"",20)}{"" +checkText(driver_contact,"-")}
                                    </span>
                                    
                                </div>
                                <div data-toggle={place} style={{paddingLeft:0}}  title={place.split("$").join("").split("#").join("")} className = "textAddress"> 
                                    {/* <span className="fa fa-location-arrow color-icon" aria-hidden="true" style = {{marginRight: 7}} /> */}
                                    <img src = "../images/icons/arrow.png" style = {{width:13}}></img>
                                    <span style = {{fontSize: 16,lineHeight : "normal",marginLeft:3, color:$(window).width()>=766?"#000":"#78AD46"}} >
                                        <b>{place1}</b>
                                        {
                                           (place2 + place3).trim()
                                        }
                                    </span>
                                   
                                </div>
                            </div>
                            
                            {
                                $(window).width()>=766?
                      
                            // <div  className="row col-4" style={{height:50, backgroundColor: "#fff"}}>
                            <div id={this.props.tname+"dvSub"} className="dvSub" >
                              {/* <div className="col-6"> */}
                                    <MeterCircle cname={this.props.tname+"_Speed"} ctype={0} cvalue={speed} vcolor={speedColor}/>
                              {/* </div>
                               <div className="col-6"> */}
                                    <MeterCircle cname={this.props.tname+"_Gas"} ctype={1} cvalue={fuel}/>
                               {/* </div> */}
                               
                               <div >
                                    <span className="pull-right smallxxx-text " aria-hidden="true" style ={{fontSize: 12,marginTop:33,fontWeight: "bold",color: "#000",whiteSpace: "nowrap", overflow:"hidden" }}>
                                        <i className="fa fa-clock-o " style ={{fontSize: 12}}></i> {getFullDate(date) +" "+time}
                                    </span>
                               </div>
                            </div>
                            :
                            <div  id={this.props.tname+"dvSub"} className="dvSub">
                            <div className="row">
                                <div className="col-12">
                                    {this.setStatus(status,"100%",speed)}
                                </div>
                                </div>
                                <div className="row">
                                <div className=" col-12">
                                    <span className="pull-right smallxxx-text  " aria-hidden="true" style ={{fontSize: 12,fontWeight: "bold",color: "#000",whiteSpace: "nowrap", overflow:"hidden" }}>
                                        <i className="fa fa-clock-o " style ={{fontSize: 12}}></i> {getFullDate(date) +" "+time}
                                    </span>
                                </div>
                                </div>
                            </div>
                            }   
                            </div>
                        
   
                        {/* {
                            $(window).width()<=548?
                            <div style={{display:"inline-block"}}>
                                <MeterCircle cname={this.props.tname+"_Speed"} ctype={0} cvalue={speed} vcolor={speedColor} small/>
                                <MeterCircle cname={this.props.tname+"_Gas"} ctype={1} cvalue={fuel} small/>
                            </div>:""
                        } */}
                        
                       
                        <input type="button" style={{width:0,height:0,border:0,position:"absolute"}} id={"txt"+this.props.tname}/>
                    </div>

                </div>
            </div>
        )
    }
}
TrackingCrad.defaultProps = {
    index:""
}

TrackingCrad.propTypes = {
    trackHistory: PropTypes.object,
    track: PropTypes.object,
    index: PropTypes.string
}

export default TrackingCrad;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TrackingCard/TrackingCrad.js